import GLOBAL from 'modules/global'

const Icon = ({ icon }: { icon: string }) => {
  const IconData = GLOBAL.icon(icon)

  return <IconData />
}

export default Icon
